import { createResource } from "@evergis/react-fetching";
import { FindUserByNameParams } from "@evergis/api/dist/__generated__/data-contracts";

import { api as evergisApi } from "../evergis/api";

export const getUsersAndRoles = createResource(
  (query: FindUserByNameParams) => async api => ({
    data: await api.security.getUsersAndRoles(query),
  }),
  { injected: evergisApi },
);
